import { useState, type CSSProperties, type KeyboardEvent } from "react";

interface Props {
  value: string | number;
  type?: "text" | "number";
  onSave: (next: string) => void;
}

const CELL: CSSProperties = {
  cursor: "pointer", padding: "2px 6px", borderRadius: 4,
  fontFamily: "var(--font-mono)", display: "inline-block",
};
const INPUT: CSSProperties = {
  width: 80, padding: "2px 6px", borderRadius: 4,
  border: "1px solid var(--d-violet)", background: "var(--d-ink-2)",
  color: "var(--d-fg)", fontFamily: "var(--font-mono)", fontSize: 13,
};

export function InlineEditCell({ value, type = "text", onSave }: Props): JSX.Element {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(String(value));

  if (!editing) {
    return (
      <span style={CELL} onClick={() => { setDraft(String(value)); setEditing(true); }}>
        {value}
      </span>
    );
  }

  function commit() {
    if (draft !== String(value)) onSave(draft);
    setEditing(false);
  }
  function cancel() {
    setDraft(String(value));
    setEditing(false);
  }
  function onKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") commit();
    else if (e.key === "Escape") cancel();
  }

  return (
    <input autoFocus type={type} style={INPUT}
           value={draft} onChange={(e) => setDraft(e.target.value)}
           onBlur={commit} onKeyDown={onKey} />
  );
}
